export var PopoverClass;
(function (PopoverClass) {
    PopoverClass["MAIN"] = "sds-popover";
    PopoverClass["BASIC"] = "sds-popover--basic";
    PopoverClass["UP"] = "sds-popover--up";
    PopoverClass["UP_LEFT"] = "sds-popover--up-left";
    PopoverClass["UP_RIGHT"] = "sds-popover--up-right";
    PopoverClass["DOWN"] = "sds-popover--down";
    PopoverClass["DOWN_LEFT"] = "sds-popover--down-left";
    PopoverClass["DOWN_RIGHT"] = "sds-popover--down-right";
    PopoverClass["LEFT"] = "sds-popover--left";
    PopoverClass["LEFT_UP"] = "sds-popover--left-up";
    PopoverClass["LEFT_DOWN"] = "sds-popover--left-down";
    PopoverClass["RIGHT"] = "sds-popover--right";
    PopoverClass["RIGHT_UP"] = "sds-popover--right-up";
    PopoverClass["RIGHT_DOWN"] = "sds-popover--right-down";
    PopoverClass["HOVERED"] = "sds-popover-hovered";
})(PopoverClass || (PopoverClass = {}));
export function getClass(placement) {
    switch (placement) {
        case 'top':
            return PopoverClass.UP;
        case 'top-start':
            return PopoverClass.UP_LEFT;
        case 'top-end':
            return PopoverClass.UP_RIGHT;
        case 'bottom':
            return PopoverClass.DOWN;
        case 'bottom-start':
            return PopoverClass.DOWN_LEFT;
        case 'bottom-end':
            return PopoverClass.DOWN_RIGHT;
        case 'left':
            return PopoverClass.LEFT;
        case 'left-start':
            return PopoverClass.LEFT_UP;
        case 'left-end':
            return PopoverClass.LEFT_DOWN;
        case 'right':
            return PopoverClass.RIGHT;
        case 'right-start':
            return PopoverClass.RIGHT_UP;
        case 'right-end':
            return PopoverClass.RIGHT_DOWN;
        default:
            return PopoverClass.UP;
    }
}
